import React, { PropTypes } from 'react';
import { AuthorizedComponent } from 'react-router-role-authorization';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import _ from 'lodash';

import {
    DROPBOX__ASSIGNMENT__REQUESTED,
    ASSIGNMENT__COPY__REQUESTED,
    ROLES__SELF__REQUESTED,
    DROPBOXES__REQUESTED,
    ASSIGNMENTS__REQUESTED
} from '../constants/actionTypes';
import Card from '../components/bootstrap/Card';
import CardHeader from '../components/bootstrap/CardHeader';
import CardBlock from "../components/bootstrap/CardBlock";
import CopyAssignmentLinks from "../components/CopyAssignmentLinks";
import SortedDropboxesSelector from '../selectors/SortedDropboxesSelector';
import { INSTRUCTOR } from "../constants/roles";
import { underscoreToSpace } from "../helpers/helpers";
import AssignmentForm, {EDIT} from "../components/AssignmentForm";

class AssignmentCopyPage extends AuthorizedComponent {

    constructor(props) {
        super(props);

        this.userRoles = props.auth.roles;
        this.notAuthorizedPath = '/not-found';

        this.state = {
            errors: {},
            sourceDropbox: null,
            targetDropbox : null
        };

        this.handleAssignmentCopy = this.handleAssignmentCopy.bind(this);
        this.handleDropboxChange = this.handleDropboxChange.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: ROLES__SELF__REQUESTED
        });
    }

    componentDidUpdate(prevProps) {
        const { assignments, dispatch, dropboxes, params, roles_self } = this.props,
            { dropboxName } = params,
            assignmentName = underscoreToSpace(params.assignmentName)
        ;

        if (prevProps.roles_self !== roles_self) {

            const hasInstructorRole = _.includes(
                _.flatMap(
                    roles_self,
                    dropbox_role => {
                        if (dropbox_role.dropbox.name === dropboxName) {
                            return dropbox_role.role;
                        }
                    }),
                INSTRUCTOR
            );

            if (hasInstructorRole) {
                if (_.size(dropboxes) < 1) {
                    dispatch({
                        type: DROPBOXES__REQUESTED,
                    });
                }

                if (_.size(assignments) < 1) {
                    dispatch({
                        type: ASSIGNMENTS__REQUESTED,
                    });
                }

                if (dropboxName && assignmentName && dropboxName.length > 0 && assignmentName.length > 0) {
                    dispatch ({
                        type: DROPBOX__ASSIGNMENT__REQUESTED,
                        payload: {
                            dropboxName : dropboxName,
                            assignmentName : assignmentName
                        }
                    });
                }
            } else {
                browserHistory.push('/not-found');
            }
        }
    }

    componentWillReceiveProps(newProps) {
        let { targetDropbox, errors } = newProps;
        this.state = {
            targetDropbox : targetDropbox,
            errors: errors
        };
    }

    handleDropboxChange(event){
        const target = event.target,
            value = target.value,
            { assignment, dropboxes } = this.props
        ;

        if (parseInt(value) > -1) {

            this.setState({
                sourceDropbox: dropboxes[assignment.dropbox.id],
                targetDropbox: dropboxes[value]
            });
        } else {
            this.setState({
                targetDropbox: null,
            });
        }
    }

    renderCourseOptions(dropbox) {
        const { roles_self } = this.props;

        return (
            [
                _.includes(
                    _.flatMap(
                        roles_self,
                        dropbox_role => {
                            if (dropbox_role.dropbox.id === dropbox.id) {
                                return dropbox_role.role;
                            }
                        }),
                    INSTRUCTOR
                )
                ? <option value={dropbox.id}>{dropbox.name}</option>
                : null
            ]
        );
    }

    checkAssignmentCollisions(assignmentName, targetDropbox){
        const { assignments } = this.props,
            collision = _.filter(
                assignments,
                assignment => {
                    return assignment.name === assignmentName
                        && assignment.dropbox.id === targetDropbox.id
                    ;
                }

            ).length > 0
        ;

        if (collision) {
            this.setState({
                errors: ["Duplicate assignment name " + assignmentName + " is not allowed."]
            });
            return true;
        } else {
            return false;
        }
    }

    handleAssignmentCopy(e) {
        e.preventDefault();

        const { targetDropbox } = this.state,
            { assignment } = this.props
        ;

        if (targetDropbox) {
            if (!this.checkAssignmentCollisions(assignment.name, targetDropbox)) {
                this.props.dispatch({
                    type: ASSIGNMENT__COPY__REQUESTED,
                    payload: {
                        dropboxId: targetDropbox.id,
                        assignmentId: assignment.id,
                    }
                });
            }
        }
    }

    render() {
        const isLoading = this.props.request.sendingRequest;

        if (isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        const {assignment, dropboxes, params} = this.props,
            {errors} = this.state
        ;

        return (
            <div className="col-md-12">
                {
                    _.map(
                        _.filter(
                            dropboxes,
                            dropbox => {
                                return dropbox.name === params.dropboxName;
                            }
                        ),
                        dropbox => {
                            return (
                                <div className="col-md-12">
                                    <div className="action-links">
                                        <CopyAssignmentLinks
                                            dropbox={dropbox}
                                            onClickSubmit={this.handleAssignmentCopy}
                                        />
                                    </div>
                                    <h3>{dropbox.name}</h3>
                                    {
                                        errors && _.map(errors, (error, i) => {
                                            return (
                                                <Card key={"error_" + i}>
                                                    <div
                                                        className="alert alert-danger alert-dismissible"
                                                        role="alert">
                                                        {error}
                                                    </div>
                                                </Card>
                                            );

                                        })
                                    }
                                    <Card>
                                        <CardBlock>
                                            {dropboxes
                                                ? (
                                                    <Card>
                                                        <CardHeader
                                                            className="bg-primary">Copy
                                                            Assignment</CardHeader>
                                                        <CardBlock>
                                                            <form
                                                                className="border-top-0">
                                                                Copying
                                                                Assignment:&nbsp;
                                                                <div
                                                                    className="ml-1 mt-3 mb-3">
                                                                    <h5>{assignment.name}</h5>
                                                                </div>
                                                                To Course:
                                                                <br/>
                                                                <div
                                                                    className="mt-3">
                                                                    <select
                                                                        onChange={this.handleDropboxChange}
                                                                        className="custom-select"
                                                                    >
                                                                        <option>---Select
                                                                            a
                                                                            Course---
                                                                        </option>
                                                                        {
                                                                            _.map(
                                                                                SortedDropboxesSelector(this.props),
                                                                                this.renderCourseOptions.bind(this)
                                                                            )
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </form>
                                                        </CardBlock>
                                                    </Card>
                                                ) : (
                                                    null
                                                )
                                            }
                                        </CardBlock>
                                    </Card>
                                </div>
                            );
                        }
                    )
                }
            </div>
        );
    }
}

AssignmentCopyPage.propTypes = {
    auth: PropTypes.object.isRequired,
    assignment: PropTypes.object.isRequired,
    assignments: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    dropboxes: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const { assignment, assignments, auth, dropboxes, request, roles_self } = state;

    return { assignment, assignments, auth, dropboxes, request, roles_self };
}

export default connect(mapStateToProps)(withRouter(AssignmentCopyPage));




/** WEBPACK FOOTER **
 ** ./src/containers/AssignmentCopyPage.js
 **/